






















































import Vue from 'vue';
import { CloseFullscreenWrapper, TriggerRefreshError } from '@/mixins';
import {
  FullscreenWrapper,
  FullscreenContent,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { ExtendMixins } from '@/services';

interface Data {
  isLoading: boolean;
  showSuccessMessage: boolean;
  successMessageSetActive: string;
  successMessageSetInactive: string;
  showErrorMessage: boolean;
  errorMessgage: string;
  refreshError: boolean;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  TriggerRefreshError,
).extend({
  name: 'UpdateAccountHold',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      isLoading: false,
      showSuccessMessage: false,
      successMessageSetActive: this.params.successMessageSetActive,
      successMessageSetInactive: this.params.successMessageSetInactive,
      showErrorMessage: false,
      errorMessgage: this.params.errorMessage,
      refreshError: false,
    };
  },
  computed: {
    isActive(): boolean {
      return this.params.accountStatus === 'Active';
    },
    heading(): string {
      return this.isActive
        ? this.$options.filters.t('update-account-hold_page-title_active')
        : this.$options.filters.t('update-account-hold_page-title_inactive');
    },
    description(): string {
      return this.isActive
        ? this.$options.filters.t('update-account-hold_page-description_active')
        : this.$options.filters.t(
            'update-account-hold_page-description_inactive',
          );
    },
    confirmText(): string {
      return this.isActive
        ? this.$options.filters.t([
            'update-account-hold_action_confirm-set-hold',
            'global_yes',
          ])
        : this.$options.filters.t([
            'update-account-hold_action_confirm-release-hold',
            'global_yes',
          ]);
    },
    successMessage(): string {
      return !this.isActive
        ? this.successMessageSetActive
        : this.successMessageSetInactive;
    },
  },
  methods: {
    updateAccountHold(): void {
      this.isLoading = true;
      this.$store
        .dispatch('updateAccountStopIndicator', {
          accountId: this.params.accountId,
          isOnHold: this.isActive,
        })
        .then(() => {
          this.refreshAccounts();
        })
        .catch(() => {
          this.showErrorMessage = true;
          this.isLoading = false;
        });
    },
    refreshAccounts(): void {
      this.$store
        .dispatch('getAccounts')
        .then(() => {
          this.showSuccessMessage = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.triggerRefreshError({
            message: [
              'update-account-hold_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenContent,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
